import React, { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import {
  AddItemContainer,
  ApplyFormInput,
  BoldText,
  Button,
  InputDiv,
  Label,
  MainTitle,
  TableInput,
  TopBar,
} from "../../../styles/styles";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { scrollToRef } from "../../../ScrollTop";

const useStyles = makeStyles({
  table: {
    width: "80%",
    paddingTop: "30px",
    margin: "0 auto",
  },
  thead: {
    borderBottom: "none",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "21px",
    color: "#6D83AE",
    background: "#F7F9FD",
  },
  button: {
    display: "block",
    marginTop: "20px",
  },
  formControl: {
    margin: "10px",
    minWidth: 120,
  },
});

const MoreOutwards = ({ setShow, details }) => {
  const classes = useStyles();
  const topbarRef = useRef(null);
  const { agency, shipping, item, order, quantity } = details;

  const items = [
    { order, item, quantity, code: "12demo" },
    { order, item, quantity, code: "33demo" },
  ];
useEffect(() => {
  scrollToRef(topbarRef)
}, [])

  return (
    <div>
      <TopBar ref={topbarRef} className="mx-4">
        <BoldText>Outward Details</BoldText>
      </TopBar>
      <AddItemContainer>
        <form>
          <Container>
            <MainTitle style={{ paddingTop: "10px" }}>Agency Details</MainTitle>
            <Row className="w-100 p-0 m-0">
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Agency Name</Label>
                  <ApplyFormInput details readOnly value={agency} />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Receiver's Name</Label>
                  <ApplyFormInput details readOnly value="Static Smith" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Phone Number</Label>
                  <ApplyFormInput details readOnly value="+91 889927DEMO" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Email</Label>
                  <ApplyFormInput
                    details
                    readOnly value="test@gmail.in"
                    type="email"
                  />
                </InputDiv>
              </Col>
            </Row>

            <MainTitle>Order Details</MainTitle>
            <Row className="w-100 p-0 m-0">
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Order Generated by</Label>
                  <ApplyFormInput
                    details
                    readOnly value="Static Rohit"
                    type="text"
                  />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Reference Number</Label>
                  <ApplyFormInput details readOnly value="88DEMO" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>P.O Number</Label>
                  <ApplyFormInput details readOnly value="77DEMO" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>P.I Number</Label>
                  <ApplyFormInput details readOnly value="222DEMO" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Eway Bill</Label>
                  <ApplyFormInput details readOnly value="xyzDEMO" type="text" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>D.C Number</Label>
                  <ApplyFormInput details readOnly value="abcDEMO" />
                </InputDiv>
              </Col>
            </Row>
            <MainTitle>Delivery Details</MainTitle>
            <Row className="w-100 p-0 m-0">
              <Col md={6} xs={12}>
                <InputDiv>
                  <Label details>Address</Label>
                  <ApplyFormInput
                    details
                    readOnly value="Chennai, Static Street 33/430"
                    type="text"
                  />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>City</Label>
                  <ApplyFormInput details readOnly value="Chennai" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>District</Label>
                  <ApplyFormInput details readOnly value="Chennai" type="text" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>State</Label>
                  <ApplyFormInput details readOnly value="Chennai" type="text" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Pincode</Label>
                  <ApplyFormInput details readOnly value="222Demo" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Mode of Transportation</Label>

                  <ApplyFormInput details readOnly value="van" type="text" />
                </InputDiv>
              </Col>
              <Col md={3} xs={12}>
                <InputDiv>
                  <Label details>Delivery Date</Label>
                  <ApplyFormInput details readOnly value={shipping} />
                </InputDiv>
              </Col>
              <Col md={12} xs={12}>
                <InputDiv>
                  <Label details>Remarks</Label>
                  <ApplyFormInput
                    details
                    readOnly value="Camera accessories"
                    type="text"
                  />
                </InputDiv>
              </Col>
            </Row>
          </Container>
          <AddItemsContainer>
            <Container>
              <MainTitle>Add Items</MainTitle>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.thead} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Item Code
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Item
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Total Qty.
                    </TableCell>
                    <TableCell
                      className={classes.thead}
                      align="center"
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, index) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          <TableInput
                            style={{ border: "none" }}
                            readOnly value={`${item.code}`}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details
                            readOnly value={`${item.item}`}
                          >
                          </TableInput>
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details
                            readOnly value={`${item.quantity}`}
                          ></TableInput>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Container>
          </AddItemsContainer>
          <div className="text-center mt-lg-5 my-2">
            <Button outline onClick={() => setShow("outwards")}>
              Go back
            </Button>
          </div>
        </form>
      </AddItemContainer>
    </div>
  );
};

export default MoreOutwards;

const AddItemsContainer = styled.div`
  @media only screen and (max-width: 1000px) {
    overflow-x: scroll;
  }
`;
const Container = styled.div`
  padding: 0 50px;
  @media only screen and (max-width: 1000px) {
    padding: 0;
  }
`;
